import { render, staticRenderFns } from "./GridBox2.vue?vue&type=template&id=086e1dce&scoped=true"
var script = {}
import style0 from "./GridBox2.vue?vue&type=style&index=0&id=086e1dce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e1dce",
  null
  
)

export default component.exports